import { PublicServiceConfig } from '@/lib/models/policy-model-v1/public-services';

export type ServiceAction = 'default' | 'block' | 'monitor' | 'allow' | undefined;

/**
 * Determines the current action for a service based on its position in the config arrays
 */
export const getServiceAction = (serviceId: string, config: PublicServiceConfig): ServiceAction => {
  const { enabled = [], disabled = [], monitored = [] } = config;

  if (disabled.includes(serviceId)) {
    return 'block';
  }
  if (enabled.includes(serviceId) && monitored.includes(serviceId)) {
    return 'monitor';
  }
  if (enabled.includes(serviceId) && !monitored.includes(serviceId)) {
    return 'allow';
  }
  if (
    !enabled.includes(serviceId) &&
    !monitored.includes(serviceId) &&
    !disabled.includes(serviceId)
  ) {
    return 'default';
  }
};

/*
 * Updates the config by applying the specified action to a service
 */
export const applyServiceAction = (
  config: PublicServiceConfig,
  serviceId: string,
  action: ServiceAction
): PublicServiceConfig => {
  const { enabled = [], disabled = [], monitored = [] } = config;

  // Remove from all arrays first
  const updatedEnabled = enabled.filter((id) => id !== serviceId);
  const updatedDisabled = disabled.filter((id) => id !== serviceId);
  const updatedMonitored = monitored.filter((id) => id !== serviceId);

  // Add back based on selected action
  switch (action) {
    case 'block':
      return {
        ...config,
        enabled: updatedEnabled,
        disabled: [...updatedDisabled, serviceId],
        monitored: updatedMonitored,
      };
    case 'monitor':
      return {
        ...config,
        enabled: [...updatedEnabled, serviceId],
        disabled: updatedDisabled,
        monitored: [...updatedMonitored, serviceId],
      };
    case 'allow':
      return {
        ...config,
        enabled: [...updatedEnabled, serviceId],
        disabled: updatedDisabled,
        monitored: updatedMonitored,
      };
    case 'default':
      return {
        ...config,
        enabled: updatedEnabled,
        disabled: updatedDisabled,
        monitored: updatedMonitored,
      };
  }
  return config;
};
